import * as component from '../app/routes/index';

const navigationConfigs = [
  {
    id: 100,
    fallbackRoute: false,
    title: 'Personal Details',
    navigation: true,
    orderState: 'InProgress',
    completionTimeEstimate: 3,
    route: '/personal-details',
    name: 'demographics',
    component: component.PersonalDetailsRoute
  },
  {
    id: 110,
    fallbackRoute: false,
    title: 'Trade-in',
    navigation: true,
    orderState: 'InProgress',
    completionTimeEstimate: 4,
    route: '/trade-in',
    name: 'tradeIn',
    component: component.TradeInRoute
  },
  {
    id: 120,
    fallbackRoute: false,
    title: 'Cash or Finance',
    navigation: true,
    orderState: 'InProgress',
    completionTimeEstimate: 2,
    route: '/payment-options',
    name: 'paymentOption',
    component: component.PaymentOptionsRoute
  },
  {
    id: 130,
    fallbackRoute: false,
    title: 'Gap Coverage',
    navigation: true,
    orderState: 'InProgress',
    completionTimeEstimate: 2,
    route: '/gap',
    name: 'gapWaiver',
    component: component.GapRoute
  },
  {
    id: 140,
    fallbackRoute: false,
    title: 'Delivery Options',
    navigation: true,
    orderState: 'InProgress',
    completionTimeEstimate: 1,
    route: '/transfer-method',
    name: 'transferMethod',
    component: component.TransferMethodRoute
  },
  {
    id: 150,
    fallbackRoute: false,
    title: 'Carvana Protection',
    navigation: true,
    orderState: 'InProgress',
    completionTimeEstimate: 1,
    route: '/carvana-protection',
    name: 'protection',
    component: component.CarvanaProtectionRoute
  },
  {
    id: 160,
    fallbackRoute: false,
    title: 'Driver\'s License',
    navigation: true,
    orderState: 'InProgress',
    completionTimeEstimate: 4,
    route: '/drivers-license',
    name: 'driversLicense',
    component: component.DriversLicenseRoute
  },
  {
    id: 170,
    fallbackRoute: false,
    title: 'Identity Verification',
    navigation: true,
    orderState: 'InProgress',
    completionTimeEstimate: 2,
    route: '/identity',
    name: 'identity',
    component: component.IdentityRoute
  },
  {
    id: 180,
    fallbackRoute: false,
    title: 'Payment',
    navigation: true,
    orderState: 'InProgress',
    completionTimeEstimate: 5,
    route: '/down-payment',
    name: 'paymentCollection',
    component: component.DownPaymentRoute
  },
  {
    id: 190,
    fallbackRoute: false,
    title: 'Review Order',
    navigation: true,
    orderState: 'InProgress',
    completionTimeEstimate: 2,
    route: '/review-order',
    name: 'order',
    component: component.ReviewOrderRoute
  },
  {
    id: 200,
    fallbackRoute: false,
    title: 'Identity',
    navigation: true,
    orderState: 'Underwriting',
    completionTimeEstimate: 2,
    route: '/identity-verification',
    name: 'identityVerification',
    component: component.IdentityVerificationRoute
  },
  {
    id: 205,
    fallbackRoute: false,
    title: 'Bank Account Verification',
    navigation: true,
    orderState: 'Underwriting',
    completionTimeEstimate: 2,
    route: '/bank-account-verification',
    name: 'bankAccountValidation',
    component: component.BankAccountVerificationRoute
  },
  {
    id: 210,
    fallbackRoute: false,
    title: 'Income',
    navigation: true,
    orderState: 'Underwriting',
    completionTimeEstimate: 5,
    route: '/income-information',
    name: 'proofOfIncome',
    component: component.IncomeInformationRoute
  },
  {
    id: 220,
    fallbackRoute: false,
    title: 'Address',
    navigation: true,
    orderState: 'Underwriting',
    completionTimeEstimate: 5,
    route: '/residency-information',
    name: 'proofOfResidency',
    component: component.ResidencyInformationRoute

  },
  {
    id: 230,
    fallbackRoute: false,
    title: 'Trade',
    navigation: true,
    orderState: 'Underwriting',
    completionTimeEstimate: 5,
    route: '/trade-documentation',
    name: 'tradeDocumentation',
    component: component.TradeDocumentationRoute

  },
  {
    id: 240,
    fallbackRoute: false,
    title: 'Additional Income',
    navigation: true,
    orderState: 'Underwriting',
    completionTimeEstimate: 5,
    route: '/additional-income',
    name: 'additionalIncomeDocumentation',
    component: component.AdditionalIncomeRoute
  },
  {
    id: 250,
    fallbackRoute: false,
    title: 'Schedule',
    navigation: true,
    orderState: 'Underwriting',
    completionTimeEstimate: 1,
    route: '/transfer-schedule',
    name: 'transferSchedule',
    component: component.TransferScheduleRoute
  },
  {
    id: 260,
    fallbackRoute: false,
    title: 'Insurance',
    navigation: true,
    orderState: 'Underwriting',
    completionTimeEstimate: 3,
    route: '/insurance-options',
    name: 'insuranceOptions',
    component: component.InsuranceOptionsRoute
  },
  {
    id: 270,
    fallbackRoute: true,
    title: 'Order Placed Dashboard',
    navigation: false,
    orderState: 'OrderPlaced',
    route: '/order-placed',
    name: 'orderPlaced',
    component: component.OrderPlacedRoute
  }
];

const GetNavigationConfigByOrderState = (orderState) => {
  return navigationConfigs.filter(x => x.orderState === orderState);
};

export default GetNavigationConfigByOrderState;
